// @ts-nocheck

import { FlowActionTypes } from '../types/actions/common';

export const stopAction = ({ stoppedAction }) => ({
  type: FlowActionTypes.STOP_ACTION,
  payload: {
    stoppedAction,
  },
});
